import React from 'react'
import { DataItemRow, Texto } from '@gravitate-js/excalibrr'
import { Col } from 'antd'
import { sortNumeric } from '@utils/general'
import { DropdownSelect } from '@components/_SiteWide/Form/DropdownSelect'

export const Vehicle = ({ driver, metadata, editing }) => {
  return (
    <Col span={16} className='right-side'>
      <Texto category='h5'>{`Vehicle`}</Texto>
      <div className='driver-form-line pt-3'>
        <DataItemRow label='Tractor' labelSpan={8} valueSpan={16}>
          <DropdownSelect
            name='tractor_number'
            editable={editing}
            options={sortNumeric(metadata.tractors)}
            placeholder='Tractor Number'
            initialValue={
              driver && driver.tractor_number && driver.tractor_number !== '' ? (
                <Texto align='right'>{driver.tractor_number}</Texto>
              ) : (
                <Texto align='right'>N/A</Texto>
              )
            }
          />
        </DataItemRow>
      </div>
      <div className='driver-form-line license-state'>
        <DataItemRow label='Trailer' labelSpan={8} valueSpan={16}>
          <DropdownSelect
            name='trailer_number'
            editable={editing}
            options={sortNumeric(metadata.trailers)}
            placeholder='Trailer Number'
            initialValue={
              driver && driver.trailer_number && driver.trailer_number !== '' ? (
                <Texto align='right'>{driver.trailer_number}</Texto>
              ) : (
                <Texto align='right'>N/A</Texto>
              )
            }
          />
        </DataItemRow>
      </div>
    </Col>
  )
}
